module.exports = __webpack_public_path__ + "static/media/march.6634408b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/march.svg
// module id = 299
// module chunks = 0